import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-administratie-koppelen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-administratie-koppelen.component.html',
  styleUrl: './tekst-administratie-koppelen.component.scss',
})
export class TekstAdministratieKoppelenComponent {}
